import React from "react";
import { Link } from "react-router";
import PracticeSearch from "../../practice/PracticeSearch";
import setModal from "../../../actions";
import MailImage from "../../../images/icons/cont-mail.svg";
import PhoneImage from "../../../images/icons/cont-phone.svg";
import WebImage from "../../../images/icons/cont-web.svg";
import editImage from "../../../images/icons/edit_white.svg";

const style = {
  display: "flex",
  flexDirection: "column"
};

const block = {
  display: "block"
};

const AppNav = ({ User, closeMenu, onLogout, onProfileClick }) => {
  let Header, AdminOptions;
  if (User.loggedIn) {
    Header = (
      <header className="side-nav__header">
        <div style={{position: "relative"}}>
          <div
            onClick={() => {
              onProfileClick();
            }}
            className="avatar"
            style={{
              backgroundImage: "url(" + User.photoURL + ")",
              
            }}
          >
            <img
              src={editImage}
              alt="Edit"
              style={{
                background: "rgba(0, 0, 0, 0.7)",
                padding: "5px",
                borderRadius: "50%",
                position: "absolute",
                bottom: "0",
                right: "-10px",
                zIndex: '2'
              }}
            />
          </div>
        </div>
        <div className="user-name">{User.displayName}</div>
        {User.loggedIn && (
          <a
            className="logout"
            onClick={() => {
              onLogout();
              closeMenu();
            }}
          >
            Logout
          </a>
        )}
      </header>
    );
  }

  if (User.admin) {
    AdminOptions = (
      <div>
        <hr />
        <small>Admin</small>
        <ul>
          <li>
            <Link style={block} onClick={closeMenu} to="/admin/users">
              Users
            </Link>
          </li>
          <li>
            <Link style={block} onClick={closeMenu} to="/admin/practices">
              Practices
            </Link>
          </li>
          <li>
            <Link style={block} onClick={closeMenu} to="/admin/therapy_areas">
              Therapy Areas
            </Link>
          </li>
          <li>
            <Link
              style={block}
              onClick={closeMenu}
              to="/admin/therapy_categories"
            >
              Therapy Categories
            </Link>
          </li>
          <li>
            <Link
              style={block}
              onClick={closeMenu}
              to="/admin/healtcare_professions"
            >
              Healthcare Professions
            </Link>
          </li>
          <li>
            <Link style={block} onClick={closeMenu} to="/admin/videos">
              Videos
            </Link>
          </li>
        </ul>
      </div>
    );
  }

  return (
    <div style={style}>
      {Header}
      <div className="side-nav__content">
        <PracticeSearch admin={false} itemClick={closeMenu} />
        <ul>
          <li>
            <Link style={block} onClick={closeMenu} to="/onboarding?nav">
              Onboarding Process
            </Link>
          </li>
          <li>
            <a href="/terms_conditions">Terms and Conditions</a>
          </li>
          <li>Frequently Asked Questions</li>
        </ul>
        {AdminOptions}
        <div className="sideContact">
          <h3>Get in touch</h3>
          <ul>
            <li>
              <img src={MailImage} />
              <a href="mailto:info@specialt.co.za">info@specialt.co.za</a>
            </li>
            <li>
              <img src={WebImage} />
              <a href="http://www.specialt.co.za/" target="_blank">
                www.specialt.co.za
              </a>
            </li>
            <li>
              <img src={PhoneImage} />
              <a href="tel:info@specialt.co.za">064 528 3195</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AppNav;



// WEBPACK FOOTER //
// ./src/components/sidenav/content/AppNav.jsx